import { ref, onMounted, onBeforeUnmount } from 'vue'

export function useCountdown(storageKey: string) {
  const timeLeft = ref(0)
  const showCountTime = ref(false)
  let timer: ReturnType<typeof setInterval> | null = null

  const startCountdown = (seconds: number) => {
    const endTime = Date.now() + seconds * 1000
    localStorage.setItem(storageKey, endTime.toString())

    const updateCountdown = () => {
      const remaining = Math.ceil((endTime - Date.now()) / 1000)
      timeLeft.value = Math.max(0, remaining)

      if (timeLeft.value === 0 && timer) {
        showCountTime.value = false
        clearInterval(timer)
        timer = null
        localStorage.removeItem(storageKey)
      }
    }

    showCountTime.value = true
    updateCountdown()
    timer = setInterval(updateCountdown, 1000)
  }

  const restoreCountdown = () => {
    const storedEndTime = Number(localStorage.getItem(storageKey))
    if (storedEndTime && storedEndTime > Date.now()) {
      showCountTime.value = true

      const updateCountdown = () => {
        const remaining = Math.ceil((storedEndTime - Date.now()) / 1000)
        timeLeft.value = Math.max(0, remaining)

        if (timeLeft.value === 0 && timer) {
          showCountTime.value = false
          clearInterval(timer)
          timer = null
          localStorage.removeItem(storageKey)
        }
      }

      updateCountdown()
      timer = setInterval(updateCountdown, 1000)
    }
  }

  onMounted(() => {
    restoreCountdown()
  })

  onBeforeUnmount(() => {
    if (timer) clearInterval(timer)
  })

  return {
    timeLeft,
    showCountTime,
    startCountdown,
  }
}
